import { useEffect } from 'react';
import { useLanguageCode } from '../../../contexts/environment';
import useIsRtl from '../../../hooks/useIsRtl';
/**
 * Set the html attributes for language and dir from the values in the localization context.
 */
const HtmlLanguageAttributes = ({ children }) => {
    const languageCode = useLanguageCode();
    const isRtl = useIsRtl();
    useEffect(() => {
        const htmlElement = document.getElementsByTagName('html')[0];
        htmlElement.setAttribute('lang', languageCode);
        htmlElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
    });
    return children;
};
export default HtmlLanguageAttributes;
//# sourceMappingURL=HtmlLanguageAttributes.js.map